<template>

  <div class="cl-search_filter">
              <h3 class="cl-search_filter_title">Show tabs</h3>  
              <div>
                 <template v-for="option in coptions">
                  <label class="cl-search_filter_checkbox label label-default radio-inline">{{option.name}}
                    <input type="checkbox"  :value="option.name" v-model="option.selected" class="flex_shrinkno">
                    
                  </label>
                </template>
              </div>		
    </div>

</template>

<script>
export default {
  name: 'checkboxtab-group',
  data :  () => ({
              coptions: [{
                          name: 'Recipes',
                          selected: true
                      }, {
     					           name: 'Ingredients',
                          selected: true
                      }, {
                          name: 'Organisations',
                          selected: true
                      }] 
              
            
        }),
  props: {
      showTab: {
        type: String,
        default:null
      }
  },
  computed:{
      myselected (){
            return this.coptions.filter(function (l) {
                return l.selected
            }).map(function (l) {
                return l.name
            })
           }
    },

  created:function(){
    var self=this;
    if(this.showTab){
        this.coptions.forEach(function(element) {
        if (element.name === self.showTab) { element.selected = true } else { element.selected = false }
      })
     }
  },
  
  watch: {
    myselected: function(val) {
      
      this.$emit('update', val)
    },
     showTab: function(newVal, oldVal) {
          if(newVal){
            this.coptions.forEach(function(element) {
            if(element.name===newVal)
              element.selected=true;
            else
              element.selected=false;
          });
          
      }
  }
  }
  

}
</script>

<style scoped>
.radio-inline {
  padding-right: 10px;
}

.label-default {
  display: inline;
  padding-right: 15px;
}

.cllabel{
  background-color: none;
  font-size: 100%;
  color:grey;
}

.checkbox-inline {
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/CheckboxTabGroup.vue